__turbopack_context__.v({
  "container": "Arrow-module-scss-module__Zd-tLq__container",
  "effects": "Arrow-module-scss-module__Zd-tLq__effects",
  "flip": "Arrow-module-scss-module__Zd-tLq__flip",
  "left": "Arrow-module-scss-module__Zd-tLq__left",
  "right": "Arrow-module-scss-module__Zd-tLq__right",
});
